import { render } from "./StarUserProfile.vue?vue&type=template&id=2b5f9824&scoped=true&ts=true"
import script from "./StarUserProfile.vue?vue&type=script&lang=ts"
export * from "./StarUserProfile.vue?vue&type=script&lang=ts"

import "./StarUserProfile.vue?vue&type=style&index=0&id=2b5f9824&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5f9824"]])

export default __exports__